import { Box, Checkbox, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Agreement } from '../../constants/agreements';
import { AgreementDialog } from '../index';
import UserAgreement from '../../pages/agreementPages/UserAgreement';
import TermsOfUse from '../../pages/agreementPages/TermsOfUse';
import PrivacyAgreement from '../../pages/agreementPages/PrivacyAgreement';
import { appColors } from "../../constants/theme";

const AgreementsList = ({ onSelectionChange, handleIsAllSelected }) => {
  const { t } = useTranslation();
  const [agreements, setAgreements] = useState([
    { name: Agreement.UserContract, label: "user-agreement", isSelected: false },
    { name: Agreement.TermsOfUse, label: "terms-of-use", isSelected: false },
    { name: Agreement.PrivacyPolicy, label: "privacy-policy", isSelected: false }
  ]);
  const [selectedAgreement, setSelectedAgreement] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  //------------- HANLDERS ----------------
  const handleOnChange = (name) => {
    setAgreements(prev =>
      prev.map(a =>
        a.name === name
          ? { ...a, isSelected: !a.isSelected }
          : a
      )
    );
  };

  const handleOnClick = (label) => {
    setSelectedAgreement(label);
    setDialogOpen(true);
  };

  const getAgreementPage = (label) => {
    switch (label) {
      case 'user-agreement':
        return <UserAgreement />;
      case 'terms-of-use':
        return <TermsOfUse />;
      case 'privacy-policy':
        return <PrivacyAgreement />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const selected = agreements
      .filter(a => a.isSelected)
      .map(a => a.name);              // enum değerleri

    onSelectionChange(selected);

    const all = agreements.every(a => a.isSelected);
    handleIsAllSelected(all);
  }, [agreements, onSelectionChange, handleIsAllSelected]);

  //------------- RETURN-------------------
  return (
    <Box sx={{ mt: 2 }}>


      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: '100%'
      }}>
        {
          agreements.map(agreement =>
          (
            <Box
              key={agreement.name}
              sx={{
                borderRadius: '16px',
                border: `1px solid ${appColors.gray200}`,
                backgroundColor: agreement.isSelected ? appColors.primaryBgHover : appColors.white,
                transition: 'all 0.3s ease',
                '&:hover': {
                  borderColor: appColors.primary,
                  backgroundColor: agreement.isSelected ? appColors.tealMint : appColors.gray50,
                  transform: 'translateY(-1px)',

                }
              }}
            >
              <Box
                onClick={() => handleOnChange(agreement.name)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  p: 1.5,
                  cursor: 'pointer',
                  borderRadius: '16px',
                  minHeight: 'auto'
                }}
              >
                <Checkbox
                  checked={agreement.isSelected}
                  disableRipple
                  size="small"
                  inputProps={{ 'aria-labelledby': t("agreement") }}
                  sx={{
                    color: appColors.gray200,
                    '&.Mui-checked': {
                      color: appColors.primary,
                      transform: 'scale(1.1)',
                    },
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(13, 148, 136, 0.1)',
                    }
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: agreement.isSelected ? appColors.primary : appColors.gray900,
                      fontWeight: agreement.isSelected ? 600 : 500,
                      fontSize: '0.85rem',
                      lineHeight: 1.3,
                      cursor: 'pointer',
                      '&:hover': {
                        color: appColors.primaryDark,
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOnClick(agreement.label);
                    }}
                  >
                    {t(agreement.label)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )
          )}
      </Box>

      {/* Sözleşme Popup */}
      <AgreementDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        agreementPage={getAgreementPage(selectedAgreement)}
      />
    </Box>
  )
}

export default AgreementsList